/**
 * El backend devuelve SIEMPRE la misma forma de error: {"error": {codigo, mensaje}}.
 * Aun asi, un proxy o un balanceador pueden colarse con HTML, asi que el parser
 * nunca asume que el cuerpo sea el esperado.
 */
export class ErrorApi extends Error {
  readonly codigo: string
  readonly mensaje: string
  readonly estado: number

  constructor(estado: number, codigo: string, mensaje: string) {
    super(mensaje)
    this.name = 'ErrorApi'
    this.estado = estado
    this.codigo = codigo
    this.mensaje = mensaje
  }

  /** El unico caso que obliga a devolver al usuario a la pantalla de acceso. */
  get esSesionCaducada(): boolean {
    return this.estado === 401
  }
}

const MENSAJE_GENERICO = 'No se ha podido completar la operacion. Intentalo de nuevo.'

export async function interpretarError(respuesta: Response): Promise<ErrorApi> {
  let codigo = 'desconocido'
  let mensaje = MENSAJE_GENERICO

  try {
    const cuerpo = await respuesta.json()
    if (cuerpo?.error?.codigo) {
      codigo = String(cuerpo.error.codigo)
      mensaje = String(cuerpo.error.mensaje ?? MENSAJE_GENERICO)
    }
  } catch {
    // Cuerpo no-JSON: un proxy intermedio o un error de red. Nos quedamos
    // con el mensaje generico, que es lo unico honesto que podemos decir.
  }

  return new ErrorApi(respuesta.status, codigo, mensaje)
}
